import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stop"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sendToExtension, createPageMayExitObservable, canUseEventBridge, addTelemetryDebug, startAccountContext, startGlobalContext, startUserContext } from '@datadog/browser-core';
import { createDOMMutationObservable } from '../browser/domMutationObservable';
import { createWindowOpenObservable } from '../browser/windowOpenObservable';
import { startInternalContext } from '../domain/contexts/internalContext';
import { LifeCycle } from '../domain/lifeCycle';
import { startViewHistory } from '../domain/contexts/viewHistory';
import { startRequestCollection } from '../domain/requestCollection';
import { startActionCollection } from '../domain/action/actionCollection';
import { startErrorCollection } from '../domain/error/errorCollection';
import { startResourceCollection } from '../domain/resource/resourceCollection';
import { startViewCollection } from '../domain/view/viewCollection';
import { startRumSessionManager, startRumSessionManagerStub } from '../domain/rumSessionManager';
import { startRumBatch } from '../transport/startRumBatch';
import { startRumEventBridge } from '../transport/startRumEventBridge';
import { startUrlContexts } from '../domain/contexts/urlContexts';
import { createLocationChangeObservable } from '../browser/locationChangeObservable';
import { startFeatureFlagContexts } from '../domain/contexts/featureFlagContext';
import { startCustomerDataTelemetry } from '../domain/startCustomerDataTelemetry';
import { startPageStateHistory } from '../domain/contexts/pageStateHistory';
import { startDisplayContext } from '../domain/contexts/displayContext';
import { startVitalCollection } from '../domain/vital/vitalCollection';
import { startCiVisibilityContext } from '../domain/contexts/ciVisibilityContext';
import { startLongTaskCollection } from '../domain/longTask/longTaskCollection';
import { startSyntheticsContext } from '../domain/contexts/syntheticsContext';
import { startRumAssembly } from '../domain/assembly';
import { startSessionContext } from '../domain/contexts/sessionContext';
import { startConnectivityContext } from '../domain/contexts/connectivityContext';
import { startDefaultContext } from '../domain/contexts/defaultContext';
import { startTrackingConsentContext } from '../domain/contexts/trackingConsentContext';
import { startEventCollection } from '../domain/event/eventCollection';
import { startInitialViewMetricsTelemetry } from '../domain/view/viewMetrics/startInitialViewMetricsTelemetry';
import { startSourceCodeContext } from '../domain/contexts/sourceCodeContext';
export function startRum(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder,
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, customVitalsState, bufferedDataObservable, telemetry, hooks, sdkName) {
  var cleanupTasks = [];
  var lifeCycle = new LifeCycle();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    return sendToExtension('rum', event);
  });
  var reportError = function reportError(error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    // monitor-until: forever, to keep an eye on the errors reported to customers
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var pageMayExitObservable = createPageMayExitObservable(configuration);
  var pageMayExitSubscription = pageMayExitObservable.subscribe(function (event) {
    lifeCycle.notify(11 /* LifeCycleEventType.PAGE_MAY_EXIT */, event);
  });
  cleanupTasks.push(function () {
    return pageMayExitSubscription.unsubscribe();
  });
  var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle, trackingConsentState) : startRumSessionManagerStub();
  if (!canUseEventBridge()) {
    var batch = startRumBatch(configuration, lifeCycle, reportError, pageMayExitObservable, session.expireObservable, createEncoder);
    cleanupTasks.push(function () {
      return batch.stop();
    });
    startCustomerDataTelemetry(telemetry, lifeCycle, batch.flushController.flushObservable);
  } else {
    startRumEventBridge(lifeCycle);
  }
  startTrackingConsentContext(hooks, trackingConsentState);
  var _startInitialViewMetr = startInitialViewMetricsTelemetry(lifeCycle, telemetry),
    stopInitialViewMetricsTelemetry = _startInitialViewMetr.stop;
  cleanupTasks.push(stopInitialViewMetricsTelemetry);
  var _startRumEventCollect = startRumEventCollection(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError),
    stopRumEventCollection = _startRumEventCollect.stop,
    startRumEventCollectionResult = _objectWithoutProperties(_startRumEventCollect, _excluded);
  cleanupTasks.push(stopRumEventCollection);
  bufferedDataObservable.unbuffer();
  // Add Clean-up tasks for Profiler API.
  cleanupTasks.push(function () {
    return profilerApi.stop();
  });
  return _objectSpread(_objectSpread({}, startRumEventCollectionResult), {}, {
    lifeCycle: lifeCycle,
    session: session,
    stopSession: function stopSession() {
      return session.expire();
    },
    telemetry: telemetry,
    stop: function stop() {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    },
    hooks: hooks
  });
}
export function startRumEventCollection(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError) {
  var cleanupTasks = [];
  var domMutationObservable = createDOMMutationObservable();
  var locationChangeObservable = createLocationChangeObservable(configuration);
  var _createWindowOpenObse = createWindowOpenObservable(),
    windowOpenObservable = _createWindowOpenObse.observable,
    stopWindowOpen = _createWindowOpenObse.stop;
  cleanupTasks.push(stopWindowOpen);
  startDefaultContext(hooks, configuration, sdkName);
  var pageStateHistory = startPageStateHistory(hooks, configuration);
  cleanupTasks.push(function () {
    return pageStateHistory.stop();
  });
  var viewHistory = startViewHistory(lifeCycle);
  cleanupTasks.push(function () {
    return viewHistory.stop();
  });
  var urlContexts = startUrlContexts(lifeCycle, hooks, locationChangeObservable);
  cleanupTasks.push(function () {
    return urlContexts.stop();
  });
  var featureFlagContexts = startFeatureFlagContexts(lifeCycle, hooks, configuration);
  startSessionContext(hooks, session, recorderApi, viewHistory);
  startConnectivityContext(hooks);
  var globalContext = startGlobalContext(hooks, configuration, 'rum', true);
  var userContext = startUserContext(hooks, configuration, session, 'rum');
  var accountContext = startAccountContext(hooks, configuration, 'rum');
  var actionCollection = startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
  cleanupTasks.push(actionCollection.stop);
  var eventCollection = startEventCollection(lifeCycle);
  var displayContext = startDisplayContext(hooks, configuration);
  cleanupTasks.push(displayContext.stop);
  var ciVisibilityContext = startCiVisibilityContext(configuration, hooks);
  cleanupTasks.push(ciVisibilityContext.stop);
  startSyntheticsContext(hooks);
  startRumAssembly(configuration, lifeCycle, hooks, reportError);
  var _startViewCollection = startViewCollection(lifeCycle, hooks, configuration, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions),
    addTiming = _startViewCollection.addTiming,
    setLoadingTime = _startViewCollection.setLoadingTime,
    startView = _startViewCollection.startView,
    setViewName = _startViewCollection.setViewName,
    setViewContext = _startViewCollection.setViewContext,
    setViewContextProperty = _startViewCollection.setViewContextProperty,
    getViewContext = _startViewCollection.getViewContext,
    stopViewCollection = _startViewCollection.stop;
  startSourceCodeContext(hooks);
  cleanupTasks.push(stopViewCollection);
  var resourceCollection = startResourceCollection(lifeCycle, configuration, pageStateHistory);
  cleanupTasks.push(resourceCollection.stop);
  var _startLongTaskCollect = startLongTaskCollection(lifeCycle, configuration),
    stopLongTaskCollection = _startLongTaskCollect.stop;
  cleanupTasks.push(stopLongTaskCollection);
  var _startErrorCollection = startErrorCollection(lifeCycle, configuration, bufferedDataObservable),
    addError = _startErrorCollection.addError;
  startRequestCollection(lifeCycle, configuration, session, userContext, accountContext);
  var vitalCollection = startVitalCollection(lifeCycle, pageStateHistory, customVitalsState);
  var internalContext = startInternalContext(configuration.applicationId, session, viewHistory, actionCollection.actionContexts, urlContexts);
  return {
    addAction: actionCollection.addAction,
    startAction: actionCollection.startAction,
    stopAction: actionCollection.stopAction,
    startResource: resourceCollection.startResource,
    stopResource: resourceCollection.stopResource,
    addEvent: eventCollection.addEvent,
    addError: addError,
    addTiming: addTiming,
    setLoadingTime: setLoadingTime,
    addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
    startView: startView,
    setViewContext: setViewContext,
    setViewContextProperty: setViewContextProperty,
    getViewContext: getViewContext,
    setViewName: setViewName,
    viewHistory: viewHistory,
    getInternalContext: internalContext.get,
    startDurationVital: vitalCollection.startDurationVital,
    stopDurationVital: vitalCollection.stopDurationVital,
    addDurationVital: vitalCollection.addDurationVital,
    addOperationStepVital: vitalCollection.addOperationStepVital,
    globalContext: globalContext,
    userContext: userContext,
    accountContext: accountContext,
    stop: function stop() {
      return cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}